import React, { Component } from 'react'

import { withRouter } from 'react-router'
import { compose } from 'react-apollo'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import './locations.css'
import withLocations from '../../../../containers/withLocations'


const SectionTitle = styled.h2`
  border-top: 1px solid ${theme.colors.tones.darker};
  color: ${theme.colors.tones.darker};
  font-size: 12px;
  font-weight: 500;
  padding-top: 30px;
  text-transform: uppercase;
`

const Controls = styled.div`
  margin-bottom: 90px;
`

const MobileControls = styled(Row)`
  ${media.sm`
    display: none;
  `}
`

const DesktopControls = styled(Row)`
  display: none;

  ${media.sm`
    display: flex;
  `}
`
const Wrapper = styled(Container)`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
${media.lg`
padding: 10px 20% 50px 20%;
`}
`
const InnerWrapper = styled.div`
width: 100%;
`

const Control = styled.button`
  background-color: ${props => props.active ? theme.colors.primary : 'white'};
  border-radius: 33px;
  border: 1px solid ${theme.colors.primary};
  color: ${props => props.active ? 'white' : theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  outline: none;
  padding: 0 0;
  text-transform: uppercase;
  transition: color 0.3s ${easing.easeOutCubic}, background-color 0.3s ${easing.easeOutCubic};
  width: 100%;
  height: 60px;
  ${media.md`
  font-size: 10px;
  `}
  ${media.lg`
  font-size: 12px;
  `}
`

const MobileControl = styled.select`
  background-color: ${props => props.active ? theme.colors.primary : 'white'};
  border-radius: 20px;
  border: 1px solid ${theme.colors.primary};
  color: ${props => props.active ? 'white' : theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  outline: none;
  padding: 15px 0;
  text-transform: uppercase;
  transition: color 0.3s ${easing.easeOutCubic}, background-color 0.3s ${easing.easeOutCubic};
  width: 100%;
  text-align-last: center;
`

const Content = styled.div`
  border-top: 1px solid ${theme.colors.tones.lighter};
  margin-bottom: 60px;
`

const Country = styled.p`
  color: ${theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  padding-top: 30px;
  text-transform: uppercase;
`

const Text = styled.div`
  font-size: 14px;
  font-weight: 300;
  margin-top: 30px;

  p {
    margin: 0;
  }
`

const Image = styled.div`
width: 100%;
background: url(${props => props.image}) space;
height:100%;
background-size: contain;
background-repeat: no-repeat;
`
const DownCol = styled(Col)`
width: 50%;
height: 100px;
margin-top: 20px;
`

class Locations extends Component {
  constructor(props) {
    super(props)

    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  state = {
    locations: [],
    region: ''
  }

  componentDidUpdate(prevProps) {
    if (this.props.optionsLocations) {
      if (!prevProps.optionsLocations || this.props.optionsLocations.locations !== prevProps.optionsLocations.locations) {
        this.setState({ locations: this.props.optionsLocations.optionsLocations.locations.sort((a, b) => a.country.localeCompare(b.country)) })
      }
    }
  }

  handleSelectChange(e) {
    this.filterByRegion(e.target.value)
  }

  //Show only 
  filterByRegion(region) {
    if (this.state.region === region || region === 'none') {
      this.setState({ locations: this.props.optionsLocations.optionsLocations.locations.sort((a, b) => a.country.localeCompare(b.country)) })
      this.setState({ region: 'none' })
    } else {
      this.setState({ region })

      const filteredList = this.props.optionsLocations.optionsLocations.locations.filter((location) =>
        location.region === region
      )

      this.setState({ locations: filteredList.sort((a, b) => a.country.localeCompare(b.country)) })
    }
  }

  //Remove http or https from displayed location's url for aesthetic purposes
  removeHttp(x) {
    if (x.slice(0, 5) === "https") {
      x = x.slice(8);
      return x
    }
    else {
      x = x.slice(7)
      return x
    }
  }

  render() {
    const { title, bgcolor } = this.props

    if (!this.props.optionsLocations) return null

    const {
      labelAfrica,
      labelAsia,
      labelAustralia,
      labelEurope,
      labelNorthAmerica,
      labelSouthAmerica,
    } = this.props.optionsLocations.optionsLocations

    return (
      <Wrapper fluid bgcolor={bgcolor}>
        <InnerWrapper>
          <Row>
            <Col>
              <SectionTitle>{title}</SectionTitle>
            </Col>
          </Row>
          <Controls>
            <MobileControls>
              <Col>
                <MobileControl
                  value={this.state.region}
                  onChange={this.handleSelectChange}
                  active={this.state.region !== null}
                >
                  <option defaultValue={'none'}>Sort</option>
                  <option value="africa">{labelAfrica}</option>
                  <option value="asia">{labelAsia}</option>
                  <option value="australia">{labelAustralia}</option>
                  <option value="europe">{labelEurope}</option>
                  <option value="north-america">{labelNorthAmerica}</option>
                  <option value="south-america">{labelSouthAmerica}</option>
                </MobileControl>
              </Col>
            </MobileControls>
            <DesktopControls>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'africa'}
                  onClick={e => this.filterByRegion('africa')}
                >
                  {labelAfrica}
                </Control>
              </Col>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'asia'}
                  onClick={e => this.filterByRegion('asia')}
                >
                  {labelAsia}
                </Control>
              </Col>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'australia'}
                  onClick={e => this.filterByRegion('australia')}
                >
                  {labelAustralia}
                </Control>
              </Col>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'europe'}
                  onClick={e => this.filterByRegion('europe')}
                >
                  {labelEurope}
                </Control>
              </Col>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'north-america'}
                  onClick={e => this.filterByRegion('north-america')}
                >
                  {labelNorthAmerica}
                </Control>
              </Col>
              <Col sm={2}>
                <Control
                  active={this.state.region === 'south-america'}
                  onClick={e => this.filterByRegion('south-america')}
                >
                  {labelSouthAmerica}
                </Control>
              </Col>
            </DesktopControls>
          </Controls>
          <Row>
            {this.state.locations && this.state.locations.map((location) => {
              return (
                <Col sm={3} key={location.title}>
                  <Content>
                    <Country>{location.country}</Country>
                    <Row>
                      <Col xs={12}>
                        <Text>
                          <p>{location.title}</p>
                          <p>{location.address}</p>
                          <p>{location.zip}</p>
                        </Text>
                        <Text>
                          <p><a href={`tel:${location.phone}`}>{location.phone}</a></p>
                          <p><a href={`mailto:${location.mail}`}>{location.mail}</a></p>
                          <p><a href={location.url} target="_blank">{this.removeHttp(location.url)}</a></p>
                        </Text>
                      </Col>
                    </Row>
                    <Row>
                      <DownCol xs={12} className="logo-column">
                        <Image image={location.img && location.img.sourceUrl}></Image>
                      </DownCol>
                    </Row>
                  </Content>
                </Col>
              )
            })}
          </Row>
        </InnerWrapper>
      </Wrapper>
    )
  }
}

export default compose(
  withRouter,
  withLocations()
  /* withQuery(() => gql`
    {
      optionsLocations {
        locations {
          country
          title
          address
          zip
          phone
          mail
          region
          url
          img {
            sourceUrl
          }
        }
        labelAfrica
        labelAsia
        labelAustralia
        labelEurope
        labelNorthAmerica
        labelSouthAmerica
      }
    }
  `, 'optionsLocations') */
)(Locations)



// WEBPACK FOOTER //
// ./src/ui/components/modules/Locations/index.js